import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IPlanQuote } from './types'

interface PlanSelectionState {
  selectedPlan: IPlanQuote | null
  paymentMode: 'annual' | 'monthly'
  installmentMonths: number | null
  policyStartDate: string | null
  customerId: string | null
}

interface SetPlanPayload {
  plan: IPlanQuote
  paymentMode: 'annual' | 'monthly'
  installmentMonths?: number
}

const SLICE_NAME = 'planSelection'

const initialState: PlanSelectionState = {
  selectedPlan: null,
  paymentMode: 'annual',
  installmentMonths: null,
  policyStartDate: null,
  customerId: null
}

const planSelectionSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setSelectedPlan: (state, action: PayloadAction<SetPlanPayload>) => ({
      ...state,
      selectedPlan: action.payload.plan,
      paymentMode: action.payload.paymentMode,
      installmentMonths:
        action.payload.paymentMode === 'monthly'
          ? action.payload.installmentMonths ?? null
          : null
    }),
    setPolicyStartDate: (state, action: PayloadAction<string>) => ({
      ...state,
      policyStartDate: action.payload
    }),
    setCustomerId: (state, action: PayloadAction<string | null>) => ({
      ...state,
      customerId: action.payload
    }),
    clearSelectedPlan: () => initialState
  },
  selectors: {
    selectSelectedPlan: (state) => state.selectedPlan,
    selectPaymentMode: (state) => state.paymentMode,
    selectInstallmentMonths: (state) => state.installmentMonths,
    selectPolicyStartDate: (state) => state.policyStartDate,
    selectCustomerId: (state) => state.customerId,
    selectPlanSelection: (state) => state
  }
})

export const {
  setSelectedPlan,
  setPolicyStartDate,
  setCustomerId,
  clearSelectedPlan
} = planSelectionSlice.actions
export const {
  selectSelectedPlan,
  selectPaymentMode,
  selectInstallmentMonths,
  selectPolicyStartDate,
  selectCustomerId,
  selectPlanSelection
} = planSelectionSlice.selectors
export default planSelectionSlice
